import { Create } from 'react-admin';
import { styled } from '@mui/material/styles';

export const HeaderContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginTop: '24px',

  '& button': {
    marginTop: '0',
  },
});
